export default __webpack_public_path__ + "static/MINION_MAGE_scaled-8e2b40c2a1398e17647d727934e6ebd3.gif";